module.exports = __webpack_public_path__ + "img/17.af69b6b0.jpg";